import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboard } from "../features/dashboard/dashboardSlice";
import Card from "../components/Card";

function Dashboard() {

    const dispatch = useDispatch();

    const { data, loading, error } = useSelector(
        (state) => state.dashboard
    );
	console.log(data);

    useEffect(() => {
        dispatch(fetchDashboard());
    }, [dispatch]);

    if (loading) {
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    if (error) {
        return <h4 className="text-danger">{error}</h4>;
    }

    return (

        <div className="container-fluid">

            <h3 className="mb-4">Dashboard</h3>

            {/* Dashboard Cards */}

            <div className="row">
			
			<div className="col-md-3">
			<div className="card bg-primary text-white">
			<div className="card-body">
			<h3>{data.totalBanks}</h3>
			<p>Total Banks</p>
			</div>
			</div>
			</div>
			
			<div className="col-md-3">
			<div className="card bg-success text-white">
			<div className="card-body">
			<h3>{data.totalBuyers}</h3>
			<p>Total Buyers</p></div>
			</div>
			</div>
			
			<div className="col-md-3">
			<div className="card bg-warning text-white">
			<div className="card-body">
			<h3>{data.totalDespatcho}</h3>
			<p>Total Despatcho</p>
			</div>
			</div>
			</div>
			
			<div className="col-md-3">
			<div className="card bg-danger text-white">
			<div className="card-body">
			<h3>{data.totalPorts}</h3>
			<p>Total Ports</p>
			</div>
			</div>
			</div>
			
            </div>

            {/* Latest Banks */}

            <div className="card shadow mt-4">

                <div className="card-header bg-primary text-white">
                    Latest Banks
                </div>

                <div className="card-body table-responsive">

                    <table className="table table-bordered table-hover">

                        <thead>

                            <tr>

                                <th>Name</th>
                                <th>Short Name</th>
                                <th>Opening Balance</th>
                                <th>Details</th>

                            </tr>

                        </thead>

                        <tbody>

                            {data.latestBanks?.length > 0 ? (

                                data.latestBanks.map((bank) => (

                                    <tr key={bank._id}>

                                        <td>{bank.name}</td>
										<td>{bank.short_name}</td>
                                        <td>{bank.opening_balance}</td>
                                        <td>
                                            {new Date(bank.createdAt).toLocaleDateString()}
                                        </td>

                                    </tr>

                                ))

                            ) : (

                                <tr>

                                    <td
                                        colSpan="4"
                                        className="text-center"
                                    >
                                        No Bank Found
                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            
            {/* Latest Bank Statement */}

            <div className="card shadow mt-4">

                <div className="card-header bg-warning">
                    Bank Statements
                </div>

                <div className="card-body table-responsive bank-statement-table-wrapper">

                    <table className="table table-bordered table-striped table-hover bank-statement-table">
        <thead>
            <tr>
                <th>S.No.</th>
                <th>Bank</th>
                <th>Transaction Date</th>
                <th>Party Type</th>
                <th>Credit (USD)</th>
                <th>Credit (BRL)</th>
                <th>Debit (BRL)</th>
                <th>Remarks</th>
                <th>Created At</th>
            </tr>
        </thead>

        <tbody>
            {data.latestBankStatement?.length > 0 ? (
                data.latestBankStatement.map((statement, index) => (
                    <tr key={statement._id}>
                        <td>{index + 1}</td>

                        <td>
                            {statement.bank?.name || "-"}
                        </td>

                        <td>
                            {statement.date
                                ? new Date(statement.date).toLocaleDateString("en-GB")
                                : "-"}
                        </td>

                        <td>
                            {statement.party?.party_type || "-"}
                        </td>
                        <td>
                            {Number(statement.credit_usd ?? 0).toLocaleString(
                                "en-US",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                            )}
                        </td>

                        <td>
                            {Number(statement.credit_brl ?? 0).toLocaleString(
                                "pt-BR",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                            )}
                        </td>

                        <td>
                            {Number(statement.debit_brl ?? 0).toLocaleString(
                                "pt-BR",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                            )}
                        </td>

                        <td>{statement.remarks || "-"}</td>

                        <td>
                            {statement.createdAt
                                ? new Date(statement.createdAt).toLocaleString("en-GB")
                                : "-"}
                        </td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan={11} className="text-center">
                        No Bank Statements Found
                    </td>
                </tr>
            )}
        </tbody>
    </table>

                </div>

            </div>

        </div>

    );

}

export default Dashboard;